export function isMobileDevice() {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent || "";
    if (/Mobi|Android|iPhone|iPod/i.test(ua)) return true;
    // small viewport = treat as mobile
    if (typeof window !== "undefined" && window.matchMedia?.("(max-width: 640px)").matches) return true;
    return false;
}
